// extracted by mini-css-extract-plugin
export default {"modal":"JournalFolderSelectionModal_modal__OtOfB"};